<template>
  <div>
    <div class="radio-group" :class="{ 'flex gap-3': horizontal }">
      <div
        v-for="option in options"
        :key="option.value"
        class="group d-flex flex-row align-items-center"
        :class="{ active: option.value === selectedValue }"
      >
        <label class="d-flex align-items-center full-width mb-0 cursor-pointer">
          <input
            class="group-radio"
            type="radio"
            :checked="option.value === selectedValue"
            @change="handleChange(option)"
          />
          <div
            class="d-flex justify-content-between align-items-center group-content full-width"
          >
            <div
              v-if="option.label || option.subtitle"
              class="d-flex flex-column justify-content-center"
            >
              <span v-if="option.label" class="group-title">
                {{ option.label }}
              </span>
              <span v-if="option.subtitle" class="group-subtitle">
                {{ option.subtitle }}
              </span>
            </div>
            <slot :name="`option-${option.value}-content`" />
          </div>
        </label>
      </div>
    </div>
    <div
      v-if="findByName(validationError, name)"
      class="text-danger error-text"
    >
      {{ findByName(validationError, name) }}
    </div>
  </div>
</template>

<script>
import { findByName } from "@/lib/vuelidate_helpers";

import useVuelidate from "@vuelidate/core";

export default {
  name: "RadioGroup",
  props: {
    condensed: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    modelValue: { type: [Number, String], default: "" },
    name: { type: String, default: "" },
    validationErrors: {
      type: Object,
      default() {
        return {
          first: () => {}
        };
      }
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  methods: {
    findByName,
    handleChange(option) {
      this.selectedValue = option.value;
    }
  }
};
</script>
